// Human-readable display names for the infrastructure service keys. Used by the
// search filter and the drill-down panel title so both stay in sync.
export const SERVICE_DISPLAY_NAMES = {
  lambda: 'AWS Lambda',
  ec2: 'Amazon EC2',
  s3: 'Amazon S3',
  rds: 'Amazon RDS',
  dynamodb: 'Amazon DynamoDB',
  ecs: 'Amazon ECS',
  apigateway: 'Amazon API Gateway',
  stepfunctions: 'AWS Step Functions',
  vpc: 'Amazon VPC',
  elasticache: 'Amazon ElastiCache',
  elb: 'Elastic Load Balancing',
  waf: 'AWS WAF',
  cloudwatch: 'Amazon CloudWatch',
  guardduty: 'Amazon GuardDuty',
  sns: 'Amazon SNS',
  sqs: 'Amazon SQS',
  cloudfront: 'Amazon CloudFront',
  secretsmanager: 'AWS Secrets Manager',
  parameterstore: 'AWS Systems Manager Parameter Store',
  ecr: 'Amazon ECR',
  eventbridge: 'Amazon EventBridge',
  kinesis: 'Amazon Kinesis',
  glue: 'AWS Glue',
  mwaa: 'Amazon MWAA',
  backup: 'AWS Backup',
  config: 'AWS Config',
  codepipeline: 'AWS CodePipeline',
  msk: 'Amazon MSK',
  acm: 'AWS Certificate Manager',
  accessanalyzer: 'IAM Access Analyzer',
  kms: 'AWS KMS',
  opensearch: 'Amazon OpenSearch',
  inspector: 'Amazon Inspector',
  transfer: 'AWS Transfer Family',
  appflow: 'Amazon AppFlow',
  securityhub: 'AWS Security Hub',
  dms: 'AWS DMS',
};

export const serviceDisplayName = (key) => SERVICE_DISPLAY_NAMES[key] || key;
